import React, { useEffect, useState } from 'react'
import MobileNav from './MobileNav.jsx'
import logo from '../../icons/GR_logo_beige.png'  
import menu from '../../photos/gran_rodeo_menu.pdf'
import {useNavigate, Link} from "react-router-dom";
import {HashLink} from 'react-router-hash-link';
import axios from 'axios';
const Navbar = (props) => {
    const [menuOpen, setMenuOpen] = useState("")

    const toggleMenu = (event) =>{
        if (menuOpen =="open") {
            setMenuOpen('closed');
        } 
        else {
            setMenuOpen('open');
        }
    };

    

    return (
        <div id='navbar' style={{display: 'flex', flexDirection: 'column'}}>
            <div className='navbar'>
                <Link to={'/'}>
                    <img src= {logo}  alt="Gran Rodeo Logo" />
                </Link>
                <ul className='nav-links'>
                    <li><Link to={'/'}>Home</Link></li>
                    <li><Link to={menu} target='_blank'>Menu</Link></li>
                    <li><HashLink smooth to={'/#hours-of-operation'}>Hours</HashLink></li>
                    <li><Link to={'/OnlineOrder'}>Order Online</Link></li>
                </ul>
                <label className='mobile-nav-button' onInputCapture={toggleMenu}>
                    <input className={`${menuOpen}`} type='checkbox' id={menuOpen} />
                </label>
            </div>
            <MobileNav opened = {menuOpen} onClose={() => toggleMenu}></MobileNav>
        </div>
    )
}
export default Navbar;